import { Record } from 'immutable';
import { Base } from './base';
import {first} from 'lodash';

export default class Contact extends Base(Record({
    id: null,
    label: 'primary',
    owner_type: 'places',
    owner_id: null,
    text: '',
    type: '',
    proxies: []
  })) {
    $create(id) {
      return this.api.post({
        resource: 'contacts'
      }, this.api.payload('contacts', id ? this.set('owner_id', id) : this))
        .then(res => this.dispatch(this.actions.receiveEntity(res.data)));
    }

    $delete() {
      return this.api.delete({
        id: this.id,
        resource: 'contacts'
      });
    }

    $get(id) {
      if (this.owner_id) id = this.owner_id;

      if (!id) return Promise.resolve(null);

      return this.api.get({
        resource: 'contacts?filter[owner_id]=' + id + '&filter[owner_type]=places'
      })
      .then(res => Promise.all(
        [res].concat(res.data.map(v => Promise.all(
          this.proxies.map(p => this.$proxy(new p({ contact_id: v.id })))
        )))
      ))
      .then(res => this.dispatch(this.actions.receiveEntities(first(res).data, 'contacts')));
    }

    $put() {
      const contact = this.state.entities.get('contacts').get(this.id);
      if (!contact || contact.equals(this)) {
        return Promise.resolve('No op');
      }

      if (this.text === '') {
        return this.$delete()
          .then(res => this.dispatch(this.actions.clearEntities('contacts')))
          .then(res => this.$get());
      }

      return this.api.put({
        id: this.id,
        resource: 'contacts'
      }, this.api.payload('contacts', this))
      .then(res => this.dispatch(this.actions.receiveEntity(res.data)));
    }
  }



// WEBPACK FOOTER //
// ./src/records/contact.js